import { Box, Modal, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ModalStyle from 'src/components/modal/ModalStyle';

/**
 * LoginModal is a component that renders a modal with a passed content and open and close functionality
 *
 * @param {Object} props - The props for the component.
 * @param {string} props.content - The content that will be rendered inside the modal
 * @param {boolean} props.open - The flag that determines if the modal should be open or closed
 * @param {function} props.onClose - The function that will be called when the modal's close button is clicked
 *
 * @returns {ReactElement} - A React element that renders the modal and its content
 */
const InfoModal = ({ title, open = false, onClose, estimated, affidavit }) => {
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={ModalStyle}>
          <Box sx={{ display: 'flex', justifyContent: 'end', mb: '2rem' }}>
            <CloseIcon
              sx={{
                color: 'grey',
                cursor: 'pointer',
                float: 'right',
              }}
              onClick={onClose}
            />
          </Box>
          <Box sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.5rem' }}>{title}</Box>
          {estimated && (
            <Box sx={{ textAlign: 'center', fontWeight: 'semi-bold', fontSize: '1.15rem' }}>
              Because we did not receive a Personal Property Tax Statement filing from you, we are
              required to create an estimated value associated with your business{' '}
              <b>UCA 59-2-307(3)</b>, we charge a minimum $100 penalty <b>UCA 59-2-307(1)(a)</b>,
              and forward the account to the Treasurer&apos;s office for collection{' '}
              <b>UCA 59-2-1302</b>. A tax bill based on an estimated value and associated fees has
              been mailed. (<em>UCA denotes Utah Code Annotated</em>)
            </Box>
          )}
          {affidavit && (
            <Box>
              The County Assessor&apos;s office has already received and is processing filing
              information for this account.
            </Box>
          )}
          <Typography fontStyle="italic" sx={{ textAlign: 'center' }}>
            Please contact the Utah County Assessor&apos;s office at 801-851-8295 if you have
            questions or believe you have reached this page in error.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'end', mt: '1rem' }}>
            <Button data-cy="close" type="submit" variant="contained" onClick={onClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default InfoModal;
